<template>
  <div>
      <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
      </base-header>

      <div class="container-fluid mt--9">

        <!-- Banner nueva versión -->
        <div v-if="showNewVersionBanner" class="card shadow bb-new-version-card">
          <div class="bb-new-version-body">
            <div class="bb-new-version-icon">
              <i class="fas fa-rocket"></i>
            </div>
            <h2 class="bb-new-version-title">¡Hay una nueva versión disponible!</h2>
            <p class="bb-new-version-text">
              El módulo de <strong>Autobacklog</strong> ha sido actualizado y ahora vive en la
              nueva consola de Canplast. Encuéntralo como se muestra en la imagen:
            </p>
            <div class="bb-demo-wrapper">
              <img :src="demoImage" alt="Demostración nueva consola" class="bb-demo-img" />
            </div>
            <a
              href="https://consola-v2.canplast.net"
              target="_blank"
              rel="noopener noreferrer"
              class="btn bb-btn-new-version"
            >
              <i class="fas fa-external-link-alt mr-2"></i>
              Ir a la nueva consola
            </a>
          </div>
        </div>

        <!-- Vista normal -->
        <div v-else>
          <div class="row">
              <div class="col-sm-8">
                  <div class="card shadow">
                      <div class="card-header bg-transparent">
                          <div style="float:right;">
                            
                            <base-dropdown style="padding-left:10px">
                                <base-button slot="title" type="secondary" class="dropdown-toggle" >
                                    {{cedis_backlog}}
                                </base-button>
                                <a class="dropdown-item" @click="cedis_backlog='CUU';cargarBacklog()">CUU</a>
                                <a class="dropdown-item" @click="cedis_backlog='MEX';cargarBacklog()">MEX</a>
                                <a class="dropdown-item" @click="cedis_backlog='GDL';cargarBacklog()">GDL</a>
                                <a class="dropdown-item" @click="cedis_backlog='QRO';cargarBacklog()">QRO</a>
                                <a class="dropdown-item" @click="cedis_backlog='MTY';cargarBacklog()">MTY</a>
                                <a class="dropdown-item" @click="cedis_backlog='MID';cargarBacklog()">MID</a>
                                <a class="dropdown-item" @click="cedis_backlog='TIJ';cargarBacklog()">TIJ</a>
                              </base-dropdown></div>
                          <h3 class="mb-0" style="padding-top:8px">{{tableData.Comments}}</h3>
                          <a v-if="tableData.Comments" :href="'http://canplast.net/backlogs/'+cedis_backlog+'.pdf'" target="_blank"><h5>Ver último PDF de material a producir</h5></a>
                      </div>
                      <div class="card-body col-sm-">
                          <div class="table-responsive">
                              <base-table thead-classes="thead-light"
                                          :data="tableData.StockTransferLines">
                                  <template slot="columns">
                                      <th>Producto</th>
                                      <th>Cantidad</th>
                                  </template>


                                  <template slot-scope="{row}">
                                    <th scope="row" >
                                        <span style="font-size:12px">{{row.ItemDescription}}</span><br>
                                        <span class="text-muted" style="font-size:10px">{{row.ItemCode}}</span>
                                    </th>
                                    <th scope="row">
                                        <span style="font-size:12px">{{row.Quantity}}</span>
                                    </th>
                                  </template>
                              </base-table>
                              
                              <center v-if="showLoader"><img src="img/loader.gif" class="img-responsive" style="width:50px;padding-bottom:5px;padding-top:13px"><br>Cargando...</center>
                              <div class="card-footer d-flex justify-content-end">
                              </div>
                          </div>
                          
                      </div>

                  </div>
              </div>
              <div class="col-sm-4">
                  <div class="card shadow">
                      <div class="card-header bg-transparent">
                          <h3 class="mb-0">Generar Autobacklog</h3>
                      </div>
                      <div class="card-body col-sm-">
                        <h2>
                         <div class="row">
                            <div class="col-sm-5" style="padding-top:8px">
                              CEDIS:
                            </div> 
                            <div class="col-sm-7">
                              <base-dropdown style="padding-left:10px">
                                <base-button slot="title" type="secondary" class="dropdown-toggle">
                                    {{cedis_backlog}}
                                </base-button>
                                <a class="dropdown-item" @click="cedis_backlog='CUU';cargarBacklog()">CUU</a>
                                <a class="dropdown-item" @click="cedis_backlog='MEX';cargarBacklog()">MEX</a>
                                <a class="dropdown-item" @click="cedis_backlog='GDL';cargarBacklog()">GDL</a>
                                <a class="dropdown-item" @click="cedis_backlog='QRO';cargarBacklog()">QRO</a>
                                <a class="dropdown-item" @click="cedis_backlog='MTY';cargarBacklog()">MTY</a>
                                <a class="dropdown-item" @click="cedis_backlog='MID';cargarBacklog()">MID</a>
                                <a class="dropdown-item" @click="cedis_backlog='TIJ';cargarBacklog()">TIJ</a>
                              </base-dropdown>
                            </div>
                         </div>
                        </h2>
                        <h2>
                          <div class="row">
                            <div class="col-sm-5" style="padding-top:7px">
                              SLITTER:
                            </div>
                            <div class="col-sm-7">
                               
                              <base-dropdown style="padding-left:10px">
                                <base-button slot="title" type="secondary" class="dropdown-toggle">
                                    {{slitter}}
                                </base-button>
                                <a class="dropdown-item" @click="slitter='Si'">Si</a>
                                <a class="dropdown-item" @click="slitter='No'">No</a>
                              </base-dropdown>
                            </div>
                          </div>
                        </h2><br>
                        <base-button block @click="generar" v-if="!showLoaderGenerando">GENERAR AUTOBACKLOG</base-button>
                        <center v-if="showLoaderGenerando"><img src="img/loader.gif" class="img-responsive" style="width:50px;padding-bottom:5px;padding-top:13px"><br>Generando autobacklog...</center>
                      </div>

                  </div>
              </div>
          </div>
        </div> <!-- /v-else -->

      </div>

  </div>
</template>
<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
import { getAuth, getIdToken } from "firebase/auth";
import demoImage from '@/assets/pantalla/nueva-consola-demo.jpg';


Vue.use(VueClipboard)
export default {
  components:{
//        SocialTrafficTable,
  },
  directives: {
    'b-tooltip': BTooltipDirective
  },
  created(){
    const auth = getAuth();
    this.user = auth.currentUser;
    this.showNewVersionBanner = true;
    getIdToken(auth.currentUser, true)
      .then((idToken) => {
        fetch('https://canplast.net:50000/api/v1/auth/verifyToken', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token: idToken })
        })
          .then(response => response.json())
          .then(responseJson => {
            localStorage.setItem('token-cpm', responseJson.token)
          })
          .catch(error => console.error(error));
      })
      .catch(error => console.log(error));
  },
  beforeMount(){
    const auth = getAuth();
    let user = auth.currentUser;
    if(user.email != 'anaduarte@canplast.com.mx' && user.email != 'salvadorbarbosa@canplast.com.mx' && user.email != 'daliahernandez@canplast.com.mx' && user.email != 'rebecahernandez@canplast.com.mx' && user.email != 'brendaterrazas@canplast.com.mx' && user.email != 'alfredoreyes@canplast.com.mx' && user.email != 'danieljimenez@canplast.com.mx' && user.email != 'kevincortes@canplast.com.mx' && user.email != 'nallelyenriquez@canplast.com.mx' && user.email != 'dianaquinonez@canplast.com.mx' && user.email != 'franciscoherrera@canplast.com.mx'){
        this.$swal.fire({
            title: "Error",
            text: "No tienes permisos para acceder a esta página",
            icon: "error",
            showConfirmButton: true,
        })
        this.$router.push({ path: '/' })
    }else{
      fetch("https://canplast.net:50000/api/v1/sap/GET/InventoryTransferRequests/CUU",{
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token':localStorage.getItem('token-cpm')
          }
        })
        .then((response) => response.json())
        .then((responseJson) => {
            // console.log(responseJson)
            this.tableData = responseJson
            this.showLoader = false;
        })
        .catch((error) => {
          console.log(error)
        });
    }
    
  },
  data() {
    return {
      tableData: [],
      showLoader: true,
      showLoaderGenerando:false,
      showCargarMasBtn: false,
      cedis_backlog:'CUU',
      slitter: 'No',
      showNewVersionBanner: true,
      demoImage,
    }
  },
  methods:{
    cargarBacklog(){
      this.tableData = []  
      this.showLoader = true;
      fetch("https://canplast.net:50000/api/v1/sap/GET/InventoryTransferRequests/"+this.cedis_backlog,{
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':localStorage.getItem('token-cpm')
        }
      })
      .then((response) => response.json())
      .then((responseJson) => {
          // console.log(responseJson)
          this.tableData = responseJson
          this.showLoader = false;
      })
      .catch((error) => {
        console.log("E",error)
      });
    },
    generar(){
      this.tableData = []
      this.showLoader = true;
      this.showLoaderGenerando = true;
      var slitter = "NOslitter"
      if(this.slitter === 'Si'){
        slitter ="slitter"
      }
      fetch('https://canplast.net:50000/api/v1/sap/POST/InventoryTransferRequests/'+slitter+'/'+this.cedis_backlog,{
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':localStorage.getItem('token-cpm')
        }
      })
      .then((response) => response.json())
      .then((responseJson) => {
          // console.log(responseJson)
          this.tableData = responseJson
          this.showLoader = false;
          this.showLoaderGenerando = false;
          if(this.slitter === 'Si'){
            var win = window.open('http://canplast.net/backlogs/'+this.cedis_backlog+'.pdf', '_blank');
            win.focus();
          }
      })
      .catch((error) => {
        console.log(error)
      });

    }
  }
};
</script>
<style>
.bb-new-version-card {
  border: none;
  overflow: hidden;
}
.bb-new-version-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 40px;
  background: linear-gradient(135deg, #fff5f5 0%, #fff 100%);
}
.bb-new-version-icon {
  font-size: 3.5rem;
  color: #f5365c;
  margin-bottom: 16px;
  animation: bb-bounce 1.4s infinite;
}
@keyframes bb-bounce {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-10px); }
}
.bb-new-version-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #32325d;
  margin-bottom: 12px;
}
.bb-new-version-text {
  font-size: 1.05rem;
  color: #525f7f;
  max-width: 600px;
  line-height: 1.7;
  margin-bottom: 24px;
}
.bb-demo-wrapper {
  width: 100%;
  max-width: 760px;
  margin-bottom: 32px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(50, 50, 93, 0.15);
  border: 1px solid #e9ecef;
}
.bb-demo-img {
  width: 100%;
  display: block;
}
.bb-btn-new-version {
  display: inline-flex;
  align-items: center;
  padding: 14px 36px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 50px;
  color: #fff !important;
  background: linear-gradient(87deg, #f5365c 0, #f55f36 200%);
  border: none;
  box-shadow: 0 6px 20px rgba(245, 54, 92, 0.35);
  text-decoration: none;
  transition: transform 0.15s, box-shadow 0.15s;
}
.bb-btn-new-version:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(245, 54, 92, 0.45);
}
</style>
